import { Component, OnDestroy, OnInit } from '@angular/core';

import { environment } from '../../../../environments/environment';

/**
 * Bandeau d'environnement : une barre fixe en haut de l'écran qui dit SUR QUOI
 * on travaille — local, dev ou staging. Elle ne s'affiche jamais en
 * production : c'est tout l'intérêt, le bandeau absent EST le signal « ici,
 * c'est pour de vrai ».
 *
 * Posé à la racine (`app.component.html`) et non dans la mise en page : la
 * connexion, l'onboarding et « pas d'accès » vivent hors de `LayoutComponent`,
 * et ce sont justement des écrans où l'on se trompe d'environnement.
 *
 * La barre MANGE sa hauteur au document plutôt que de flotter par-dessus : la
 * classe `has-env-bar` posée ici sur le corps décale la page et raccourcit les
 * `h-screen` d'autant (voir `styles.css`). Sans cela, elle recouvrirait le haut
 * de la barre latérale et 100vh dépasserait de sa hauteur sur chaque écran.
 */
@Component({
  selector: 'app-env-banner',
  standalone: true,
  templateUrl: './env-banner.component.html'
})
export class EnvBannerComponent implements OnInit, OnDestroy {
  /**
   * L'environnement à annoncer, ou `null` en production. `datadogEnv` sert de
   * nom parce qu'il est déjà LE nom de l'environnement partout ailleurs
   * (Datadog, PostHog) : un quatrième vocabulaire n'apporterait rien.
   */
  readonly env: string | null = environment.production ? null : environment.datadogEnv;

  /** Le domaine, en clair : deux onglets « dev » peuvent être deux machines. */
  readonly domain = environment.domain;

  ngOnInit(): void {
    if (this.env) {
      document.body.classList.add('has-env-bar');
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('has-env-bar');
  }
}
